export default __webpack_public_path__ + "static/media/background-semi-transparent.6edafc2d.png";